/**
 * Which surface the chat tree is mounted in.
 *
 * `UprightChatInner` is shared verbatim between the wide standalone `/chat`
 * route and the narrow side panel — the only structural difference is the
 * `.chat-side-panel-body` ancestor the side panel wraps it in, which CSS keys
 * off. Some render-time logic needs the same distinction (e.g. the welcome
 * screen decides whether suggestion-chip labels need the narrow-panel
 * character cap), and DOM sniffing from React is brittle, so we publish the
 * surface through a tiny context instead.
 *
 * Default `'full-page'`: the `/chat` route mounts `UprightChatInner` with no
 * provider, so it reads the default; the side panel wraps its instance in
 * `<ChatSurfaceContext.Provider value="side-panel">`.
 */
import { createContext, useContext } from 'react';

export type ChatSurface = 'full-page' | 'side-panel';

export const ChatSurfaceContext = createContext<ChatSurface>('full-page');

export function useChatSurface(): ChatSurface {
  return useContext(ChatSurfaceContext);
}
